/**
 * Utility functions for Google Maps integration
 */

/**
 * Generate Google Maps Static API URL for satellite view of a property
 * @param address - Property address
 * @param width - Image width in pixels (default: 400)
 * @param height - Image height in pixels (default: 300)
 * @param zoom - Zoom level 1-20 (default: 18 for property level detail)
 * @returns Google Maps Static API URL
 */
export function getPropertySatelliteImageUrl(
  address: string,
  width: number = 400,
  height: number = 300,
  zoom: number = 18
): string {
  const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
  
  if (!apiKey) {
    console.warn('Google Maps API key not found. Using placeholder image.');
    return `https://via.placeholder.com/${width}x${height}/e5e7eb/6b7280?text=Map+Unavailable`;
  }

  const baseUrl = 'https://maps.googleapis.com/maps/api/staticmap';
  const params = new URLSearchParams({
    center: address,
    zoom: zoom.toString(),
    size: `${width}x${height}`,
    maptype: 'satellite',
    markers: `color:red|${address}`,
    key: apiKey,
    scale: '2' // High DPI for better quality
  });

  return `${baseUrl}?${params.toString()}`;
}

/**
 * Generate Google Maps Static API URL for hybrid view (satellite + roads/labels)
 */
export function getPropertyHybridImageUrl(
  address: string,
  width: number = 400,
  height: number = 300,
  zoom: number = 18
): string {
  const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
  
  if (!apiKey) {
    console.warn('Google Maps API key not found. Using placeholder image.');
    return `https://via.placeholder.com/${width}x${height}/e5e7eb/6b7280?text=Map+Unavailable`;
  }

  const baseUrl = 'https://maps.googleapis.com/maps/api/staticmap';
  const params = new URLSearchParams({
    center: address,
    zoom: zoom.toString(),
    size: `${width}x${height}`,
    maptype: 'hybrid',
    markers: `color:red|${address}`,
    key: apiKey,
    scale: '2'
  });

  return `${baseUrl}?${params.toString()}`;
}
